import napStyles from './../nap.json'

export default {
  border: `solid 1px ${napStyles.colors.SecondaryGreySteel}`,
  nameColor: napStyles.colors.PrimaryBlack,
  descriptionColor: napStyles.colors.SecondaryGreySky,
  priceColor: napStyles.colors.PrimaryBlack,
  salePriceColor: napStyles.colors.SecondaryRed,
  badge: {
    type: 'Label',
    name: '7',
    color: napStyles.colors.SecondaryGreySky,
    letterSpacing: '0.15em'
  }
}
